import GLOBAL_URL from '../../url';
export const WAVELIGHT_URL = `${GLOBAL_URL}/api/wavelight-backend/wavelight`;
export const WAVE_URL = `${GLOBAL_URL}/api/wavelight-backend/wave`;
export const TECHNIQUE_URL = `${GLOBAL_URL}/api/wavelight-backend/technique`;
export const RESEARCH_URL = `${GLOBAL_URL}/api/wavelight-backend/research`;
